export { default as DefaultPage } from './DefaultPage';
export { default as GranadaAlbaicinGrid } from './GranadaAlbaicinGrid';



// WEBPACK FOOTER //
// ./src/features/granada-and-albaicin/index.js